import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 125 15",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "fill-rule": "nonzero",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.062 11.037V.361H0V14.64h9.24v-3.602H4.062zm11.632.19V9.09h4.779V5.864h-4.78V3.76h5.32v-3.4h-9.31V14.64h9.486v-3.411h-5.495zm14.94-4.218v2.48h3.614c-.458 1.1-1.77 1.827-3.3 1.827-2.203 0-3.648-1.546-3.648-3.804 0-2.282 1.47-3.828 3.649-3.828 1.484 0 2.786.773 3.312 1.976h4.201C37.847 2.342 34.727 0 30.912 0c-4.482 0-7.715 3.168-7.715 7.512 0 4.344 3.293 7.488 7.752 7.488 4.556 0 7.665-3.32 7.665-7.991h-7.98zm14.66 4.219V9.09h4.779V5.864h-4.78V3.76h5.32v-3.4h-9.31V14.64h9.486v-3.411h-5.495zM62.85.36v7.491L57.262.362h-3.508v14.277h3.884V6.891l5.78 7.748h3.316V.361H62.85zm13.256 0h-5.89V14.64h5.89c4.393 0 7.511-2.984 7.511-7.15 0-4.173-3.106-7.128-7.511-7.128zm-.19 10.676h-1.673V3.964h1.674c2.154 0 3.59 1.406 3.59 3.525 0 2.106-1.436 3.548-3.59 3.548z",
    fill: "#111224"
  }),
  /*#__PURE__*/_createElementVNode("g", { fill: "#C5AB80" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M94.368.343H89.11v14.414h1.838v-5.18h3.42c2.787 0 4.867-1.981 4.867-4.618 0-2.653-2.1-4.616-4.867-4.616zm-.095 7.484h-3.325V2.094h3.325c1.799 0 3.086 1.22 3.086 2.865 0 1.647-1.287 2.868-3.086 2.868zM111.058 14.757h1.993L106.884.343h-1.716l-6 14.414h1.955l1.433-3.451h7.047l1.455 3.451zm-5.006-11.926 2.86 6.818h-5.67l2.81-6.818zM125 .343h-2.014l-4.338 6.962-4.316-6.962h-2.013l5.37 8.665v5.75h1.896V9.01z" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }